import styled from "styled-components";
import plusIcon from "../../../icons/square-plus-solid.svg";
import nestImage from "../../../globals/images/nest.png";

export const Container = styled.div`
  color: white;
`;

export const InnerContainer = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  margin-bottom: 20px;
`;

export const Title = styled.div`
  text-align: center;
  font-size: 30px;
  padding-top: 20px;
  padding-bottom: 20px;
`;

export const BoxesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const OuterBoxesContainer = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

export const AddButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

export const WarningTextStyle = styled.div`
  color: yellow;
  text-align: center;
  height: 50px;
  align-items: center;
  display: flex;

  @media (max-width: 768px) {
    padding: 0 20px 20px 20px;
  }
`;

export const CircularPlusButton = styled.div`
  width: 60px;
  height: 60px;
  color: white;
  font-size: 55px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  outline: none;
  background-image: url(${plusIcon});
  background-repeat: no-repeat;
  background-position: center;
`;

export const LogoContainer = styled.div`
  background-image: url(${nestImage});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 60px;
  height: 60px;
`;

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
`;

export const OuterContainerHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  max-width: 1440px;
  margin-top: 20px;
`;
